import { render } from "./PurchasingBarActions.vue?vue&type=template&id=c510dfd2"
import script from "./PurchasingBarActions.vue?vue&type=script&lang=js"
export * from "./PurchasingBarActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__